// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { KindSkill, TagKindSkill } from "../schema";
import { serialize_KindSkill_internal, deserialize_KindSkill_internal } from "./KindSkill";

export function serialize_TagKindSkill_internal(value: TagKindSkill): unknown {
  return ((value: { discriminator: KindSkill; id: bigint; kind: KindSkill }): unknown => {
    return {
      discriminator: ((value: KindSkill): unknown => {
        return serialize_KindSkill_internal(value);
      })(value["discriminator"]),
      id: ((value: bigint): unknown => {
        return value;
      })(value["id"]),
      kind: ((value: KindSkill): unknown => {
        return serialize_KindSkill_internal(value);
      })(value["kind"]),
    };
  })(value);
}
export function serialize_TagKindSkill(obj: TagKindSkill): string {
  return renderJsonWithNumbersAsBigint(serialize_TagKindSkill_internal(obj));
}
export function deserialize_TagKindSkill_internal(value: unknown): ParserResult<TagKindSkill> {
  return ((
    value: unknown,
  ): ParserResult<{
    discriminator: KindSkill;
    id: bigint;
    kind: KindSkill;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/TagKindSkill]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/TagKindSkill]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "discriminator")) {
      return { success: false, reason: `[#/components/schemas/TagKindSkill/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
    }
    const parsed_discriminator = ((): ParserResult<KindSkill> => {
      return ((value: unknown): ParserResult<KindSkill> => {
        return deserialize_KindSkill_internal(value);
      })(value["discriminator"]);
    })();
    if (!parsed_discriminator.success) {
      return { success: false, reason: parsed_discriminator.reason };
    }
    if (!hasProp(value, "id")) {
      return { success: false, reason: `[#/components/schemas/TagKindSkill/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
    }
    const parsed_id = ((): ParserResult<bigint> => {
      return ((value: unknown): ParserResult<bigint> => {
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/TagKindSkill/id]: '${value}' expected to be of type bigint or number.` };
      })(value["id"]);
    })();
    if (!parsed_id.success) {
      return { success: false, reason: parsed_id.reason };
    }
    if (!hasProp(value, "kind")) {
      return { success: false, reason: `[#/components/schemas/TagKindSkill/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
    }
    const parsed_kind = ((): ParserResult<KindSkill> => {
      return ((value: unknown): ParserResult<KindSkill> => {
        return deserialize_KindSkill_internal(value);
      })(value["kind"]);
    })();
    if (!parsed_kind.success) {
      return { success: false, reason: parsed_kind.reason };
    }
    return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
  })(value);
}
export function deserialize_TagKindSkill(str: string): ParserResult<TagKindSkill> {
  return deserialize_TagKindSkill_internal(parseJsonWithNumbersAsBigint(str));
}
